import React from 'react';
import * as R from 'ramda';
import {
  required,
  SelectInput,
  useInput,
} from 'react-admin';
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
} from '@material-ui/core';

import { partTimeHours } from 'data';

const validateRequired = [required('Required')];
const validateDays = (value) =>
  value === '0000000' ? 'Select at least one day' : undefined;

const days = [
  { label: 'Mon', name: 'Monday', index: 1 },
  { label: 'Tue', name: 'Tuesday', index: 2 },
  { label: 'Wed', name: 'Wednesday', index: 3 },
  { label: 'Thu', name: 'Thursday', index: 4 },
  { label: 'Fri', name: 'Friday', index: 5 },
  { label: 'Sat', name: 'Saturday', index: 6 },
  { label: 'Sun', name: 'Sunday', index: 0 },
];

const sessionsChoices = [
  { id: 1, name: '1 session' },
  { id: 2, name: '2 sessions' },
];

const ensureDaysValue = R.pipe(
  R.defaultTo('0000000'),
  R.when((value) => value.length < 7, (value) => value.padEnd(7, '0')),
);

const updateDay = (value, dayIndex, checked) =>
  R.pipe(
    ensureDaysValue,
    R.split(''),
    R.update(dayIndex, checked ? '1' : '0'),
    R.join(''),
  )(value);

const TimetableDaysInput = ({ disabled, ...props }) => {
  const {
    input,
    isRequired,
    meta: { touched, error },
  } = useInput(props);
  const value = ensureDaysValue(input.value);

  return (
    <FormControl
      component="fieldset"
      required={isRequired}
      error={touched && !!error}
      disabled={disabled}
    >
      <FormLabel component="legend">Days</FormLabel>
      <FormGroup row>
        {days.map((day) => (
          <FormControlLabel
            key={day.name}
            label={day.label}
            labelPlacement="top"
            style={{ marginLeft: 0, marginRight: 16, minWidth: 48 }}
            control={
              <Checkbox
                checked={value[day.index] === '1'}
                onChange={(event) =>
                  input.onChange(
                    updateDay(value, day.index, event.target.checked),
                  )
                }
                name={day.name}
              />
            }
          />
        ))}
      </FormGroup>
      {touched && error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

const CohortB2bTimetableInputs = ({
  defaultSessions = 1,
  disabled = false,
  format,
}) => {
  const shouldShowHours = format !== 'pt';

  return (
    <>
      <Box mt="1em">
        <TimetableDaysInput
          source="timetable.days"
          validate={[...validateRequired, validateDays]}
          disabled={disabled}
        />
      </Box>
      <Box display={{ sm: 'block', md: 'flex' }} mt="1em">
        <Box flex={1} mr={{ md: '2em' }}>
          <SelectInput
            label="Sessions"
            source="sessions"
            choices={sessionsChoices}
            defaultValue={defaultSessions}
            validate={validateRequired}
            disabled={disabled}
            variant="standard"
            fullWidth
          />
        </Box>
        {shouldShowHours && (
          <Box flex={1} mr={{ md: '2em' }}>
            <SelectInput
              source="timetable.time.0.start_time"
              label="Start Time"
              choices={partTimeHours}
              optionText="id"
              validate={validateRequired}
              disabled={disabled}
              variant="standard"
              fullWidth
            />
          </Box>
        )}
        {shouldShowHours && (
          <Box flex={1}>
            <SelectInput
              source="timetable.time.0.end_time"
              label="End Time"
              choices={partTimeHours}
              optionText="id"
              validate={validateRequired}
              disabled={disabled}
              variant="standard"
              fullWidth
            />
          </Box>
        )}
        {shouldShowHours ? null : <Box flex={2} />}
      </Box>
    </>
  );
};

export default CohortB2bTimetableInputs;
